import type { IPathBaseParam } from "./path";
import type { IInteractiveExamLatestAttemptGetAllParams } from "./types";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { ICourseResponse } from "@api/courses/types";
import type { IInteractiveExamAttemptResponse } from "@api/courses/exams/interactive/attempts/types";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<IInteractiveExamAttemptResponse, { course: ICourseResponse }>
  >,
  IPathBaseParam,
  IPaginationParams & IInteractiveExamLatestAttemptGetAllParams
>("courses.exams.interactive.interactiveExamAttempt.latest");

export const latest = {
  ...getAllApis,
};
